import gql from 'graphql-tag';
import { PRODUCT_PLANOGRAM_DETAIL_FRAGMENT } from '../product';

export const PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT = gql`
	fragment planogramItemPlanogramDetail on PlanogramItem {
		id
		price
		reportedPrice
		selection
		enabled
		inactive
		parlevel
		capacity
		quantity
		row
		column
		decrementQuantityOnSale
		isIngredient
		isFavourite

		planogramItemStatistics {
			id
			lastSaleTime
			lastProductChangeTime
			quantitySoldSinceLastRestock
			salesLast365Days
			salesLast30Days
			salesLast14Days
			salesLast7Days
			spoilageLast30Days
			previousProduct {
				id
				name
			}
		}
		parlevelUnlocked
		ignoreProductDynamicParlevelsOverride
		product {
			...productPlanogramDetail
		}
		queuedProduct {
			id
			name
			imageUrl
			HCGCategory
			HFDCategory
			measurementUnit
			isFreshFood
			overrideDynamicParlevelsSettings
		}
		queuedProductType
		queuedPrice
		queuedPriceType
		queuedParlevel
		queuedParlevelType
		queuedCapacity
		queuedCapacityType
		planogramItemGroupId
		priceBookLocked
		priceBookPrice
		priceBookUnsubsidisedPrice
		priceBookSubsidyApplied
		priceBookSubsidyRuleLabel
		priceBookApplied
		priceBook {
			id
			name
		}

		expiryDates

		rawDMP
		finalDMP
		dmpLastCalculated

		destroyed
		created
	}
	${PRODUCT_PLANOGRAM_DETAIL_FRAGMENT}
`;
